import { LOGIN_DATA, LOGIN_ERROR_DATA, LOGIN_HIDE_ERROR_DATA, LOGIN_START_LOADER, LOGIN_STOP_LOADER, } from "../interface/iClientLoginData";
const initalState = {
    data: {
        jwtToken: "",
        accTyp: "",
        userID: "",
        emaildId: "",
        accountCode: "",
        lgnSrc: "",
        isImpersonated: false,
        registeredGuestAccount: false,
        clientAccount: false,
        accValDays: 0,
        name: "",
        mobile: "",
        status: "",
        message: "",
        registeredDate: "",
        pan: "",
        accountTypesArray: [],
        vendorSource: "",
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    loader: false,
};
const ClientLoginDataReducers = (state = initalState, action) => {
    switch (action.type) {
        case LOGIN_DATA:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.payload.data) });
        case LOGIN_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case LOGIN_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initalState.errorData });
        case LOGIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case LOGIN_STOP_LOADER: {
            return Object.assign(Object.assign({}, state), { loader: false });
        }
        default:
            return Object.assign({}, state);
    }
};
export default ClientLoginDataReducers;
